import * as R from "ramda";

import { isAdmin } from "./user";

export const formatTeamUsers = (users, team) =>
  R.evolve({
    users: R.pipe(
      R.map(id =>
        R.pipe(
          R.find(R.propEq("id", id)),
          R.defaultTo({}),
          R.pick(["id", "name"])
        )(users)
      ),
      R.reject(R.isEmpty)
    )
  })(team);

export const parseTeamUsers = R.evolve({ users: R.pluck("id") });

export const hydratedTeams = ({
  opportunities: { list: opportunitiesList },
  teams,
  user
}) => {
  const groupedOpportunities = R.groupBy(
    R.prop("team"),
    opportunitiesList || []
  );

  return R.map(
    team =>
      R.mergeRight(team, {
        opportunities: R.propOr([], team.id, groupedOpportunities),
        belongsToTeam: Boolean(
          isAdmin(user) ||
            R.propEq("owner", user.id, team) ||
            R.pipe(
              R.propOr([], "users"),
              R.find(R.propEq("id", user.id)),
              Boolean
            )(team)
        )
      }),
    teams || []
  );
};
